import React, { useEffect } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { storage, delegation } from "../providers/config/httpServiceConfig";

import Header from "../components/Header";
import MainLayout from "../components/MainLayout";
import AdminLayout from "../components/AdminLayout";
import Footer from "../components/Footer";
import ErrorBoundary from "../components/ErrorBoundary";
import { getActiveDelegations } from "../reducers/user";
// import AdminRoute from "./AdminRoute";

function Full(props) {
  const [token, mainToken, language] = useSelector(({ user, language }) => [
    user.user.token,
    user.mainUser.token,
    language
  ]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getActiveDelegations());
  }, []);

  axios.defaults.headers.common.Token = token;
  axios.defaults.headers.common.Language = language.locale;
  storage.defaults.headers.common.Token = token;
  delegation.defaults.headers.common.Token = mainToken;

  return (
    <div className="app">
      <Header {...props} />
      <ErrorBoundary>
        <main className="main main-route">
          <Switch>
            <Route path="/splus" name="Splus" component={MainLayout} />
            <Route
              path="/administration"
              name="Administration Panel"
              component={AdminLayout}
            />
            <Redirect from="/" to="/splus" />
          </Switch>
          <Footer {...props} bgColor="transparent" textColor="#444444" />
        </main>
      </ErrorBoundary>
    </div>
  );
}

export default Full;
